import { useSyncExternalStore } from "react";

/**
 * F-pin (CEO 2026-09-19, inspirado no "cadeado" do eDSP mas com ALFINETE):
 * fixa um CLIENTE ou um CHANTIER e as pesquisas do ERP passam a filtrar por
 * ele até soltar. Guardado em localStorage (por navegador), escopado por
 * empresa — pino de outra empresa é ignorado pelas telas.
 */
export type PinValue = {
  kind: "customer" | "chantier";
  id: number;
  label: string;
  companyId: number;
};

const KEY = "gestion.pin";
const listeners = new Set<() => void>();
let cacheStr: string | null | undefined;
let cacheVal: PinValue | null = null;

function read(): PinValue | null {
  let s: string | null = null;
  try {
    s = localStorage.getItem(KEY);
  } catch {
    s = null;
  }
  if (s === cacheStr) return cacheVal;
  cacheStr = s;
  try {
    cacheVal = s ? (JSON.parse(s) as PinValue) : null;
  } catch {
    cacheVal = null;
  }
  return cacheVal;
}

export function setPin(v: PinValue | null): void {
  try {
    if (v) localStorage.setItem(KEY, JSON.stringify(v));
    else localStorage.removeItem(KEY);
  } catch {
    // storage indisponível: pino vive só até o reload
    cacheStr = undefined;
    cacheVal = v;
  }
  listeners.forEach((l) => l());
}

export function usePin(): PinValue | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      const onStorage = (e: StorageEvent) => {
        if (e.key === KEY) cb();
      };
      window.addEventListener("storage", onStorage);
      return () => {
        listeners.delete(cb);
        window.removeEventListener("storage", onStorage);
      };
    },
    read,
    () => null,
  );
}
